import { ChangeDetectionStrategy, Component } from '@angular/core';
import { backNavigation } from '@softline/application';
import { EmptyStateComponent, TranslatePipe } from '@softline/ui-core';

@Component({
  selector: 'soft-kundenabfrage-customer-input',
  templateUrl: './customer-input.component.html',
  styleUrl: './customer-input.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [EmptyStateComponent, TranslatePipe],
})
export class CustomerInputComponent {
  constructor() {
    backNavigation('/');
  }
}
